module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('form', [_c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Klas")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Bijvoorbeeld: AH1c"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group",
    class: {
      error: _vm.containsError('level')
    }
  }, [_c('label', {
    attrs: {
      "for": "level"
    }
  }, [_vm._v("Niveau")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.level),
      expression: "level"
    }],
    attrs: {
      "name": "level",
      "id": "level",
      "disabled": !_vm.isCreating || _vm.isCreated
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.level = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Kies een niveau")]), _vm._l((_vm.availableLevels), function(level) {
    return _c('option', {
      domProps: {
        "value": level.id
      }
    }, [_vm._v("Jaar " + _vm._s(level.year))])
  })], 2)]), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: ('modal__footer'),
      expression: "'modal__footer'"
    }],
    staticClass: "action-wrapper"
  }, [(!_vm.isCreating || _vm.isCreated) ? _c('a', {
    staticClass: "tag button-timid button-timid--warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.detachGroup($event)
      }
    }
  }, [_vm._v("Verwijder van mijn overzicht")]) : _vm._e(), _c('primary-button', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.isCreating ? 'Volgende' : 'Opslaan'))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57e348b6","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/groups/settings/General.vue
// module id = Ukaq
// module chunks = 0 1